import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ErrorHandlingService } from '../general/error-handling.service';

@Injectable({
  providedIn: 'root',
})
export class MyTeamsService {
  backendUrl: string = environment.backendUrl;

  constructor(
    private http: HttpClient,
    private errorHandlingService: ErrorHandlingService
  ) {}

  getTeamsAndModuleAssignments(): Observable<any> {
    return this.http
      .get<any>(`${this.backendUrl}/myTeam/teamsAndModuleAssignments`)
      .pipe(
        map((result) => result),
        tap((res) => {
          const outcome = res ? 'fetched' : 'did not find';
          console.log(
            `myteams get teams module assignment results: ${outcome}`
          );
        }),
        catchError((error) => {
          return this.errorHandlingService.handleError<any>(
            `my_teams_team_and_module_assignment_choices`
          )(error);
        })
      );
  }

  getTeamMembersDetail(
    teamUuid: string,
    moduleAssignmentUuid: string
  ): Observable<any> {
    return this.http
      .get<any>(
        `${this.backendUrl}/myTeam/teamMembersDetail?teamUuid=${teamUuid}&moduleAssignmentUuid=${moduleAssignmentUuid}`
      )
      .pipe(
        map((result) => result),
        tap((res) => {
          const outcome = res ? 'fetched' : 'did not find';
          console.log(`myteams get team members details results: ${outcome}`);
        }),
        catchError((error) => {
          return this.errorHandlingService.handleError<any>(
            `my_teams_members_details`
          )(error);
        })
      );
  }

  getModuleAssignmentSummary(
    teamUuid: string,
    moduleAssignmentUuid: string
  ): Observable<any> {
    return this.http
      .get<any>(
        `${this.backendUrl}/myTeam/moduleAssignmentSummary?teamUuid=${teamUuid}&moduleAssignmentUuid=${moduleAssignmentUuid}`
      )
      .pipe(
        map((result) => result),
        tap((res) => {
          const outcome = res ? 'fetched' : 'did not find';
          console.log(`myteams get module assignment summary: ${outcome}`);
        }),
        catchError((error) => {
          return this.errorHandlingService.handleError<any>(
            `my_teams_module_assignment_summary`
          )(error);
        })
      );
  }

  getCallCountPerDay(
    teamUuid: string,
    moduleAssignmentUuid: string
  ): Observable<any> {
    return this.http
      .get<any>(
        `${this.backendUrl}/myTeam/callCountPerDay?teamUuid=${teamUuid}&moduleAssignmentUuid=${moduleAssignmentUuid}`
      )
      .pipe(
        map((result) => result),
        tap((res) => {
          const outcome = res ? 'fetched' : 'did not find';
          console.log(`myteams get call count per day: ${outcome}`);
        }),
        catchError((error) => {
          return this.errorHandlingService.handleError<any>(
            `my_teams_call_count_per_day`
          )(error);
        })
      );
  }

  getCallsSummary(
    teamUuid: string,
    moduleAssignmentUuid: string
  ): Observable<any> {
    return this.http
      .get<any>(
        `${this.backendUrl}/myTeam/callsSummary?teamUuid=${teamUuid}&moduleAssignmentUuid=${moduleAssignmentUuid}`
      )
      .pipe(
        map((result) => result),
        tap((res) => {
          const outcome = res ? 'fetched' : 'did not find';
          console.log(`myteams get call summary: ${outcome}`);
        }),
        catchError((error) => {
          return this.errorHandlingService.handleError<any>(
            `my_teams_call_summary`
          )(error);
        })
      );
  }

  getTeamMembersActivity(
    teamUuid: string,
    moduleAssignmentUuid: string
  ): Observable<Blob> {
    const options = {
      responseType: 'blob' as 'json',
    };

    return this.http
      .get<Blob>(
        `${this.backendUrl}/myTeam/teamMembersActivity?teamUuid=${teamUuid}&moduleAssignmentUuid=${moduleAssignmentUuid}`,
        options
      )
      .pipe(
        catchError((error) => {
          return this.errorHandlingService.handleError<Blob>(
            `my_teams_team_members_activity`
          )(error);
        })
      );
  }
}
